import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { Ref } from "vue";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface GetByIdMercuryTransactionsQueryOptions {
  id: Ref<string>;
}

export const getByIdMercuryTransactionsQuery = (
  options: GetByIdMercuryTransactionsQueryOptions,
) => {
  return queryOptions({
    queryKey: ["mercury-transactions", "get-by-id", options.id],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["getByIdMercuryTransactions"][200]
    > =>
      handleClientMethod(
        getClient().GET("/mercury-transactions/{id}", {
          params: {
            path: {
              id: options.id.value,
            },
          },
        }),
      ),
  });
};
